<template>
    <div @click="$emit('CloseSignatory')" class="transition-all	 test flex flex-col fixed top-0 left-0 w-screen h-screen  items-center justify-center  z-40 bg-[#00000063] backdrop-blur-[2px]  text-lg">
        <div :class="{'border-[#12760A]': success ,'border-[#AB0000]': !success ,}" class="w-[700px] rounded-lg border-[2px] hover:transition-all	 bg-white">
            <div :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class=" flex flex-col items-center py-10 gap-3 shadow-2xl ">
                <div >
                    <SuccessLogo        v-if="SuccessLogo" />
                    <ApproveLogo        v-if="ApproveLogo" />
                    <ErrorLogo          v-if="ErrorLogo" />
                    <DisapprovedLogo    v-if="DisapprovedLogo"/>
                    <DeleteLogo         v-if="DeleteLogo"/>
                </div>
                <p class="font-semibold text-white text-xl tracking-wide">{{ header }}</p>
                <p class="text-white text-sm">{{ header1 }}</p>
                <input v-if="remarks" type="text" placeholder="Type your reason for disapproval here..." class="w-[90%] text-sm p-3 rounded-lg px-6 outline-none text-[#4b4b4b]" v-model="remarksValue">
            </div>
            <div class="h-[80px] flex justify-center items-center gap-5 ">
                <div v-if="remarks" class="flex gap-10">
                    <button :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px]" @click="$emit('disapprove',remarksValue)" >Disapprove</button>
                    <button  class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px] bg-[#9da09d]" @click="$emit('close')">Cancel</button>
                </div>
                <div v-else>
                    <button :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px]" @click="$emit('close')">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from "vue"
import SuccessLogo     from "./PromptSvg/SuccessSvg.vue"
import ApproveLogo     from "./PromptSvg/ApproveSvg.vue"
import ErrorLogo       from "./PromptSvg/ErrorSvg.vue"
import DisapprovedLogo from "./PromptSvg/DisapprovedSvg.vue"
import DeleteLogo      from "./PromptSvg/DeleteSvg.vue"

export default defineComponent({
    components:{
        SuccessLogo,
        ApproveLogo,
        ErrorLogo,
        DisapprovedLogo,
        DeleteLogo,
    },
    data(){
        return{
            DataType:'',
            header:'',
            header1:'',
            SuccessLogo:false,
            ApproveLogo:false,
            ErrorLogo: false,
            success:true,
            remarksValue:'',
            DeleteLogo:false
        }
    },
    props:{
        type:{
            type: String
        },
        remarks:{
            type: Boolean,
            default: false
        }
    
    },
    mounted(){
      this.DataType = this.type
      this.changeDisplay()
    },
    methods:{
        changeDisplay(){
            if(this.DataType === "HRFORM"){
                this.header      = 'HR Request/s Application Sent!'
                this.header1     = 'OHR Will Contact You if Your Documents are ready for Releasing.'
                this.success = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "LVFORM"){
                this.header      = 'Leave Request Application Sent!'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "TRAININGFORM"){
                this.header      = 'Training Requistion Request Sent!!'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "CONFORM"){
                this.header      = 'Consideration Request Application Sent!'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "TRAINFORM"){
                this.header      = 'Training Request Application Sent!'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "APPROVE"){
                this.header      = 'Approved'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.ApproveLogo = true
            }
            else if(this.DataType === "RECOMMEND"){
                this.header      = 'RECOMMENDED'
                this.header1     = 'To check status of application click Here.'
                this.success = true
                this.ApproveLogo = true
            }
            else if(this.DataType === "RECOMMENDDISAPPROVED"){
                this.header      = 'DISAPPROVED'
                this.header1     = 'To check status of application click Here.'
                this.success     = false
                this.DisapprovedLogo = true
            }
            else if(this.DataType === "PASSWORDCHANGED"){
                this.header      = 'PASSWORD SUCCESFULLY CHANGED'
                this.header1     = 'Your password has been updated. You can now log in with your new credentials.'
                this.success     = true
                this.SuccessLogo = true
            }
            else if(this.DataType === "VALIDATION"){
                this.header      = 'VALIDATION ERROR'
                this.header1     = 'Please ensure that all required data has been entered.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "NOSIGNATORY"){
                this.header      = 'NO SIGNATORY FOUND'
                this.header1     = 'Please call OHR to add Digital Signatories to your Office.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "NOJD"){
                this.header      = 'NO JOB DESCRIPTON'
                this.header1     = 'To Assign Job descripton go to Personnel Services Module.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "DISSAPROVEREMARKSLEAVE"){
                this.header      = 'Deny Leave Application?'
                this.header1     = 'Leave Request During This Dates Will Be Disapprove.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "DISSAPROVEREMARKSTRAINING"){
                this.header      = 'Deny Training Application?'
                this.header1     = 'Training Request During This Dates Will Be Disapprove.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "DISSAPROVEREMARKSCONSI"){
                this.header      = 'Deny Consideration Application?'
                this.header1     = 'Consideration Request During This Date Will Be Disapprove.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "SUCCESCREATEADMINACC"){
                this.header      = 'Succesfully Created New Admin Account'
                this.header1     = 'To modify or delete the admin account, go to the Admin Account Module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "DELETE"){
                this.header      = 'Succesfully Deleted'
                this.header1     = 'The data has been permanently removed.'
                this.DeleteLogo  = true
                this.success     = true
            }
            else if(this.DataType === "UPDATE"){
                this.header      = 'Succesfully Updated'
                this.header1     = 'The data has been permanently removed.'
                this.SuccessLogo  = true
                this.success     = true
            }
            else if(this.DataType === "UPDATEANC"){
                this.header      = 'Succesfully Updated'
                this.header1     = 'An updated announcement has been made.'
                this.SuccessLogo  = true
                this.success     = true
            }
            else if(this.DataType === "UPDATENEWS"){
                this.header      = 'Succesfully Updated'
                this.header1     = 'An updated newsletter has been made.'
                this.SuccessLogo  = true
                this.success     = true
            }
            else if(this.DataType === "ADDNEWSLETTER"){
                this.header      = 'Newsletter Posted Successfully'
                this.header1     = 'To view post, go to the e-IHUB account.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDANC"){
                this.header      = 'New Announcement Posted Successfully'
                this.header1     = 'To view your open posts, go to the employees hub.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDDIVISION"){
                this.header      = 'Successsfully Added New Office/Division'
                this.header1     = 'To modify the Division, go to the Option Modification Module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDDEPT"){
                this.header      = 'Successsfully Added New Department'
                this.header1     = 'To modify the Department, go to the Option Modification Module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDSEC"){
                this.header      =  'Successfully Added New Section'
                this.header1     =  'To modify the Section, go to the Option Modification Module.'
                this.SuccessLogo =  true
                this.success     =  true
                this.ErrorLogo   =  false
            }
            else if(this.DataType === "ADDPOS"){
                this.header      =  'Successfully Added New Position'
                this.header1     =  'To modify the Position, go to the Option Modification Module.'
                this.SuccessLogo =  true
                this.success     =  true
                this.ErrorLogo   =  false
            }
            else if(this.DataType === "UPDATEOPTION"){
                this.header      = 'Successfully Updated'
                this.header1     = 'To modify, go to the Option Modification Module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "INVPASS"){
                this.header      = 'ERROR'
                this.header1     = 'The username or password is incorrect.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "WRONGCPASS"){
                this.header      = 'Validation Error'
                this.header1     = 'Make certain that you have entered the right current password.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "ADDLVRC"){
                this.header      = 'Successfully Added Leave Record'
                this.header1     = 'To modify or delete Leave Record, go to the Personnel Services Module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "LVEXS"){
                this.header      = 'Leave Record Already Exists.'
                this.header1     = ''
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "LVUPDATE"){
                this.header      = 'Successfully Updated Leave Record'
                this.header1     = 'To check your Leave Record go to Personnel Services module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADD201"){
                this.header      = 'Successfully Added 201 FILES'
                this.header1     = 'To check your Uploaded 201 Files go to Personnel Services module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            
            else if(this.DataType === "DEPENDENT"){
                this.header      = 'Successfully Added New Dependent'
                this.header1     = 'To check the updated list of dependents, go to the employee profile module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "UPDATEINFO"){
                this.header      = 'Employee Information Successfully Updated'
                this.header1     = 'The information you entered has been successfully applied.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDNEWEMP"){
                this.header      = 'Successfully Added New Employee Information'
                this.header1     = "To edit employee's information go to employee profile module."
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDPOLICY"){
                this.header      = 'Successfully Uploaded File'
                this.header1     = 'To check your uploaded file go to Policies Procedures module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDFORM"){
                this.header      = 'Successfully Added New Form'
                this.header1     = 'To check your new added Form go to File Maintenance module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "EDITFORM"){
                this.header      = 'Successfully Updated Form'
                this.header1     = 'To check your Edited Form go to File Maintenance module.'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "ADDSIGN"){
                this.header      = 'Created signatories is successfully added'
                this.header1     = 'To add or remove a signatories go to signatory module'
                this.SuccessLogo = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "DELSIGN"){
                this.header      = 'Signatories Succesfully Deleted.'
                this.header1     = 'To add or remove a signatories go to signatory module'
                this.DeleteLogo  = true
                this.success     = true
                this.ErrorLogo   = false
            }
            else if(this.DataType === "HRRECEIVED"){
                this.header       = 'Succesfully Received Employee Request'
                this.header1      = 'To check the status of employee request, go to the Form Request module.'
                this.SuccessLogo  = true
                this.success      = true
                this.ErrorLogo    = false
            }
            else if(this.DataType === "EMPTY"){
                this.header      = 'ERROR'
                this.header1     = 'Please enter your username or password.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "NEWPASSWORD"){
                this.header      = 'ERROR'
                this.header1     = 'Password does not match'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "SAMEPASS"){
                this.header      = 'ERROR'
                this.header1     = 'Previous password cannot be the same as the current password.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "MESSAGEVALIDATION"){
                this.header      = 'ERROR'
                this.header1     = 'No selection made. Please provide the required information.'
                this.success     = false
                this.ErrorLogo   = true
            }
            else if(this.DataType === "PASSNOTVALID"){
                this.header      = 'ERROR'
                this.header1     = 'Your password does not meet the required criteria.'
                this.success     = false
                this.ErrorLogo   = true
            }
            
       
            
        }
    }

})




</script>